import React, { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { pxToRem } from "@/util/common";
import { Image } from "antd-mobile";
import i18n, { changeLanguage, Language, supportedLanguages } from "@/locales";
import { DownFill } from "antd-mobile-icons";

const CustomLanguage: React.FC<{
	style?: React.CSSProperties;
}> = ({ style }) => {
	const classes = useStyles();
	const [visible, setVisible] = useState(false);
	const [currentLanguage, setCurrentLanguage] = useState<Language>();
	const data = supportedLanguages;

	useEffect(() => {
		const selectedLanVal = i18n.language;
		const language = supportedLanguages.find(
			(item) => item.val === selectedLanVal
		);
		setCurrentLanguage(language);
	}, []);

	return (
		<div className={classes.languageWrap}>
			<div
				onClick={() => {
					setVisible(!visible);
				}}
				className="content"
			>
				<Image
					src={require("@/assets/images/sideBar/language.png")}
					width={pxToRem(24)}
					height={pxToRem(24)}
				/>
				<span>{currentLanguage?.name}</span>
				<DownFill color="#5E71B7" />
			</div>
			{visible ? (
				<ul style={style}>
					{data.map((item, index) => (
						<li
							onClick={() => {
								setVisible(!visible);
								changeLanguage(item.val);
								setCurrentLanguage(item);
							}}
							key={index}
						>
							{item.name}
						</li>
					))}
				</ul>
			) : null}
		</div>
	);
};

export default CustomLanguage;

const useStyles = createUseStyles({
	languageWrap: {
		position: "relative",
		display: "flex",
		flexDirection: "column",
		justifyContent: "end",
		"& .content": {
			display: "flex",
			alignItems: "center",
			gap: pxToRem(10),
			height: pxToRem(34),
			border: "1px solid #2F3A62",
			backgroundColor: "#12141C",
			borderRadius: pxToRem(10),
			padding: {
				left: pxToRem(14),
				right: pxToRem(14),
			},
			fontWeight: 500,
			fontSize: pxToRem(12),
			color: "#FFFFFF",
		},
		"& >ul": {
			position: "absolute",
			width: "100%",
			borderRadius: pxToRem(10),
			right: pxToRem(0),
			textAlign: "center",
			padding: {
				top: pxToRem(5),
				bottom: pxToRem(5),
			},
			backgroundColor: "#0C0D14",
			"& >li": {
				fontSize: pxToRem(16),
				fontWeight: "400",
				color: "#FFFFFF",
				lineHeight: pxToRem(28),
			},
		},
	},
});
